export default __webpack_public_path__ + "static/media/secondKitchen.f999f492.jpg";